// extracted by mini-css-extract-plugin
export default {"cardHead":"ActiveCustomers_cardHead__KJ6TD","cardTitle":"ActiveCustomers_cardTitle__6vG4i","chart":"ActiveCustomers_chart__Tl69g"};